import { createElement } from 'react';
import { render } from 'react-dom';
import withLazyLoad from '../../lazy_load';

export default () => {
  const liveChatContainer = document.createElement('div');
  liveChatContainer.className = 'zendesk-live-chat-wrapper';
  liveChatContainer.id = 'zendesk-live-chat-container';

  document.getElementById('root').appendChild(liveChatContainer);

  render(
    createElement(withLazyLoad()('zendeskLiveChat')),
    document.querySelector('#zendesk-live-chat-container'),
  );
};
